import {
  createTagRequest,
  CreateTagRequestType,
  deleteTagRequest,
  fetchTagsRequest,
} from 'api';
import { setAuthLoading, setNotification, setTags } from 'state/actions';
import { TypedDispatch } from 'state/types';

export const fetchTags = () => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await fetchTagsRequest();

    dispatch(setTags(response?.data.rows));
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const createTag =
  (data: CreateTagRequestType) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await createTagRequest(data);

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const deleteTag = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await deleteTagRequest(id);

    dispatch(setNotification(response?.data?.message));

    return response?.status;
  } finally {
    dispatch(setAuthLoading(false));
  }
};
